import { useParams } from "react-router-dom";
import AcoesDaRegua from "./AcoesDaEtapa";
import { EditarNomeRegua } from "./EditarNomeRegua";
import EtapaDaRegua from "./EtapaDaRegua";
import ValidacaoRegua from "./ValidacaoRegua";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import { useCallback, useEffect, useState } from "react";
import {
    CadastrarEtapaReguaController,
    GetReguaController,
    ListarAcoesReguaPorEtapaController,
    ListarReguaEtapaController,
} from "../../../../Controllers/Automacao/Regua/GestaoDeRegua/GestaoDeReguaControllers";
import {
    IAcoesReguaEtapa,
    IRegua,
    IReguaEtapa,
} from "../../../../Interfaces/Automacao/Regua/GestaoDeRegua/GestaoDeReguaInterfaces";
import { IComponentModal } from "../../../../Components/Modais/IModalComponent";
import { useForm } from "react-hook-form";

interface IFormData {
    DS_NOME_ETAPA: string;
    NR_ETAPA: number;
    FL_COBRANCA_PREVENTIVA: boolean;
}

export default function EditarRegua() {
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();
    const { IdRegua } = useParams<{ IdRegua: string }>();

    const { reset } = useForm<IReguaEtapa>();

    const [LstEtapaRegua, setLstEtapaRegua] = useState<Array<IReguaEtapa>>();

    const [ID_CASO_COBRANCA_REGUA_ETAPA, setID_CASO_COBRANCA_REGUA_ETAPA] =
        useState(0);
    const [LstAcoesEtapaRegua, setLstAcoesEtapaRegua] =
        useState<Array<IAcoesReguaEtapa>>();

    const [DadosRegua, setDadosRegua] = useState<IRegua>();

    const [FLAG, setFLAG] = useState(false);

    const {
        execute: updateListReguaEtapa,
        loading: updateListReguaEtapaLoading,
    } = useAsyncCallback(async () => {
        ListarReguaEtapaController(Number.parseInt(IdRegua)).then((res) => {
            setLstEtapaRegua(res);
            ListarReguaEtapa();
        });
    }, [IdRegua]);

    const { execute: ListarReguaEtapa, value: lstReguaEtapa } =
        useAsyncCallback(
            () => ListarReguaEtapaController(Number.parseInt(IdRegua)),
            [IdRegua]
        );

    const updateListAcoesReguaPorEtapa = useCallback(() => {
        if (ID_CASO_COBRANCA_REGUA_ETAPA) {
            ListarAcoesReguaPorEtapaController(
                ID_CASO_COBRANCA_REGUA_ETAPA
            ).then((res) => {
                ListarReguaEtapa();
                setLstAcoesEtapaRegua(res);
            });
        }
    }, [ID_CASO_COBRANCA_REGUA_ETAPA, ListarReguaEtapa]);

    const { execute: CadastrarEtapaRegua, loading: cadastroEtapaReguaLoading } =
        useAsyncCallback((formData: IFormData) =>
            CadastrarEtapaReguaController({
                DS_NOME_ETAPA: formData.DS_NOME_ETAPA,
                FL_COBRANCA_PREVENTIVA: formData.FL_COBRANCA_PREVENTIVA,
                NR_ETAPA: formData.NR_ETAPA,
                ID_CASO_COBRANCA_REGUA: Number(IdRegua),
                ID_CASO_COBRANCA_REGUA_ETAPA: 0,
            })
        );

    const onSubmit = (formData: IFormData) => {
        CadastrarEtapaRegua(formData).then((res) => {
            setShow(false);
            reset();
            ListarReguaEtapa();
            updateListReguaEtapa();
        });
    };

    useEffect(() => {
        GetReguaController(Number.parseInt(IdRegua)).then((res) => {
            setDadosRegua(res);
            if(res.FL_VALIDADO!)
                setFLAG(res.FL_VALIDADO!);
        });

        updateListReguaEtapa();
        updateListAcoesReguaPorEtapa();
    }, [updateListReguaEtapa, updateListAcoesReguaPorEtapa, IdRegua]);

    const controlSizePerPage = [2];
    if (LstEtapaRegua && LstEtapaRegua.length > 2)
        controlSizePerPage.push(LstEtapaRegua.length);

    return (
        <>
            <div className="card card-custom gutter-b">
                <div className="card-header card-header-tabs-line d-flex justify-content-between g-4">
                    <h4 className="d-flex align-items-center flex-grow-1 mb-0">
                        <EditarNomeRegua idRegua={Number(IdRegua)} />
                    </h4>
                    <div className="card-toolbar">
                        <ul className="nav nav-tabs nav-bold nav-tabs-line">
                            <li className="nav-item">
                                <a
                                    className="nav-link active"
                                    data-toggle="tab"
                                    href="#EtapaDaRegua"
                                >
                                    <span className="nav-icon">
                                        <i className="fas fa-tasks"></i>
                                    </span>
                                    <span className="nav-text">
                                        Etapas Da Régua
                                    </span>
                                </a>
                            </li>

                            <li className="nav-item">
                                <a
                                    className={`nav-link ${
                                        lstReguaEtapa?.length === 0
                                            ? "disabled"
                                            : ""
                                    }`}
                                    data-toggle="tab"
                                    href="#AcoesDaRegua"
                                >
                                    <span className="nav-icon">
                                        <i className="fas fa-cog"></i>
                                    </span>
                                    <span className="nav-text">
                                        Ações Da Régua
                                    </span>
                                </a>
                            </li>

                            <li className="nav-item">
                                <a
                                    className="nav-link"
                                    data-toggle="tab"
                                    href="#ValidacaoRegua"
                                >
                                    <span className="nav-icon">
                                        <i className="fas fa-check-circle"></i>
                                    </span>
                                    <span className="nav-text">
                                        Validação Da Régua
                                    </span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="card-body">
                    <div className="tab-content">
                        <div
                            className="tab-pane fade show active"
                            id="EtapaDaRegua"
                            role="tabpanel"
                            aria-labelledby="EtapaDaRegua"
                        >
                            <EtapaDaRegua
                                LstEtapaRegua={LstEtapaRegua}
                                updateList={updateListReguaEtapa}
                                IdRegua={IdRegua}
                                modal={modal}
                                setModal={setModal}
                                show={show}
                                setShow={setShow}
                                onSubmit={onSubmit}
                                ListarReguaEtapa={ListarReguaEtapa}
                            />
                        </div>

                        <div
                            className="tab-pane fade"
                            id="AcoesDaRegua"
                            role="tabpanel"
                            aria-labelledby="AcoesDaRegua"
                        >
                            <AcoesDaRegua
                                ID_CASO_COBRANCA_REGUA_ETAPA={
                                    ID_CASO_COBRANCA_REGUA_ETAPA
                                }
                                IdRegua={IdRegua}
                                LstAcoesEtapaRegua={LstAcoesEtapaRegua}
                                setID_CASO_COBRANCA_REGUA_ETAPA={
                                    setID_CASO_COBRANCA_REGUA_ETAPA
                                }
                                setLstAcoesEtapaRegua={setLstAcoesEtapaRegua}
                                updateListAcoesReguaPorEtapa={
                                    updateListAcoesReguaPorEtapa
                                }
                                modal={modal}
                                setModal={setModal}
                                show={show}
                                setShow={setShow}
                                DadosRegua={DadosRegua}
                                ListarReguaEtapa={ListarReguaEtapa}
                                lstReguaEtapa={lstReguaEtapa}
                                setDadosRegua={setDadosRegua}
                                cadastroEtapaReguaLoading={
                                    cadastroEtapaReguaLoading
                                }
                                updateListReguaEtapaLoading={
                                    updateListReguaEtapaLoading
                                }
                            />
                        </div>
                        <div
                            className="tab-pane fade"
                            id="ValidacaoRegua"
                            role="tabpanel"
                            aria-labelledby="ValidacaoRegua"
                        >
                            <ValidacaoRegua
                                DadosRegua={DadosRegua}
                                FLAG={FLAG}
                                IdRegua={IdRegua}
                                setDadosRegua={setDadosRegua}
                                setFLAG={setFLAG}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
